
(() => {
 const nav=document.querySelector('.bp-app-nav'), sheet=document.querySelector('#bp-app-categories');
 if(!nav||!sheet)return;
 nav.querySelectorAll('a').forEach(a=>{if(new URL(a.href).pathname===location.pathname)a.setAttribute('aria-current','page');});
 nav.querySelector('[data-bp-categories]').addEventListener('click',e=>{if(!matchMedia('(min-width:0px)').matches)return;e.preventDefault();sheet.showModal();});
 sheet.querySelector('[data-bp-close]').addEventListener('click',()=>sheet.close());
 sheet.addEventListener('click',e=>{if(e.target===sheet){const r=sheet.getBoundingClientRect();if(e.clientY<r.top||e.clientY>r.bottom)sheet.close();}});
 nav.querySelector('[data-bp-search]').addEventListener('click',e=>{e.preventDefault();sheet.showModal();sheet.querySelector('input[type=search]').focus();});
 const source=document.querySelector('#cart-icon-bubble');
 const count=nav.querySelector('[data-bp-app-count]');
 const sync=()=>{const n=source?.querySelector('.cart-count-bubble span[aria-hidden=true]')?.textContent.trim()||'0';count.textContent=n;count.hidden=n==='0';};
 if(source)new MutationObserver(sync).observe(source,{childList:true,subtree:true,characterData:true});
 document.addEventListener('shopify:section:unload',()=>{if(sheet.open)sheet.close();});
})();

(() => {
 const media=matchMedia('(min-width:0px)'), reduce=matchMedia('(prefers-reduced-motion:reduce)');
 let cleanup=()=>{};
 const init=()=>{
  cleanup();
  const rail=document.querySelector('#popular-choices .bp-discovery__grid');
  if(!media.matches||!rail||rail.children.length<2)return;
  const originals=[...rail.children], labels=document.querySelector('[data-bp-loop-labels]')?.dataset;
  const copies=originals.map(item=>{const copy=item.cloneNode(true);copy.dataset.bpLoopCopy='';copy.setAttribute('aria-hidden','true');copy.querySelectorAll('a,button,[tabindex]').forEach(el=>el.tabIndex=-1);if(copy.matches('a,button'))copy.tabIndex=-1;rail.append(copy);return copy;});
  const control=document.createElement('span');
  let paused=reduce.matches, touching=false, focused=false, pointer=false, frame=0, previous=0, position=rail.scrollLeft;
  const label=()=>{control.textContent=paused?labels?.play:labels?.pause;control.setAttribute('aria-pressed',String(paused));};
  label();
  control.addEventListener('click',()=>{paused=!paused;label();});
  const touchStart=()=>{touching=true;paused=true;};const touchEnd=()=>{touching=false;position=rail.scrollLeft;};
  const enter=()=>{pointer=true;};const leave=()=>{pointer=false;position=rail.scrollLeft;};
  const focusIn=()=>{focused=true;};const focusOut=()=>{focused=false;position=rail.scrollLeft;};
  rail.addEventListener('pointerdown',touchStart,{passive:true});rail.addEventListener('wheel',touchStart,{passive:true});rail.addEventListener('pointerup',touchEnd,{passive:true});
  rail.addEventListener('touchstart',touchStart,{passive:true});rail.addEventListener('touchend',touchEnd,{passive:true});rail.addEventListener('touchcancel',touchEnd,{passive:true});
  rail.addEventListener('pointerenter',enter);rail.addEventListener('pointerleave',leave);rail.addEventListener('focusin',focusIn);rail.addEventListener('focusout',focusOut);
  const tick=time=>{
   const elapsed=previous?Math.min(time-previous,48):0;previous=time;
   const distance=copies[0].offsetLeft-originals[0].offsetLeft;
   if(!paused&&!touching&&!pointer&&!focused&&!document.hidden&&distance>0){
    position+=elapsed*0.025;
    if(position>=distance)position-=distance;
    rail.scrollLeft=position;
   }else position=rail.scrollLeft;
   frame=requestAnimationFrame(tick);
  };
  frame=requestAnimationFrame(tick);
  cleanup=()=>{cancelAnimationFrame(frame);copies.forEach(x=>x.remove());control.remove();rail.scrollLeft=0;rail.removeEventListener('pointerdown',touchStart);rail.removeEventListener('wheel',touchStart);rail.removeEventListener('pointerup',touchEnd);rail.removeEventListener('touchstart',touchStart);rail.removeEventListener('touchend',touchEnd);rail.removeEventListener('touchcancel',touchEnd);rail.removeEventListener('pointerenter',enter);rail.removeEventListener('pointerleave',leave);rail.removeEventListener('focusin',focusIn);rail.removeEventListener('focusout',focusOut);};
 };
 init();media.addEventListener('change',init);reduce.addEventListener('change',init);document.addEventListener('shopify:section:load',init);
})();

(() => {
 const mobile=matchMedia('(min-width:0px)');
 const raise=()=>{
  const nav=document.querySelector('.bp-app-nav'),dock=document.querySelector('.bp-cart-dock');
  [dock,nav].filter(Boolean).forEach(el=>{
   if(!('showPopover' in el))return;
   if(mobile.matches){
    el.setAttribute('popover','manual');
    if(!el.matches(':popover-open'))el.showPopover();
   }else{
    if(el.matches(':popover-open'))el.hidePopover();
    el.removeAttribute('popover');
   }
  });
 };
 const init=()=>{
  raise();
  const preview=document.querySelector('#PBarNextFrameWrapper');
  if(preview&&!preview.dataset.bpNavWatch){
   preview.dataset.bpNavWatch='true';
   preview.addEventListener('toggle',()=>{
    const nav=document.querySelector('.bp-app-nav'),dock=document.querySelector('.bp-cart-dock');
    if(mobile.matches)[dock,nav].filter(Boolean).forEach(el=>{if(el.matches(':popover-open'))el.hidePopover();});
    raise();
   });
  }
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
 mobile.addEventListener('change',init);
 document.addEventListener('shopify:section:load',init);
 const watch=new MutationObserver(init);
 watch.observe(document.body,{childList:true});
 setTimeout(()=>watch.disconnect(),15000);
})();

(() => {
 const rail=document.querySelector('#popular-choices .bp-discovery__grid');
 if(!rail)return;
 let down=false,lastX=0,startX=0,dragged=false;
 rail.addEventListener('pointerdown',e=>{if(e.pointerType!=='mouse'||e.button!==0)return;down=true;dragged=false;lastX=e.clientX;startX=e.clientX;});
 rail.addEventListener('pointermove',e=>{if(!down)return;if(Math.abs(e.clientX-startX)>6)dragged=true;if(dragged){rail.setPointerCapture(e.pointerId);rail.scrollLeft-=e.clientX-lastX;lastX=e.clientX;}});
 const release=()=>{down=false;};
 rail.addEventListener('pointerup',release);rail.addEventListener('pointercancel',release);
 rail.addEventListener('click',e=>{if(dragged){e.preventDefault();dragged=false;}},true);
})();
